import { createReactBlockSpec } from "@blocknote/react";
import { ButtonBlock } from "./ButtonBlock";
import { InlineButton } from "./InlineButton";

export const ButtonBlockSpec = createReactBlockSpec(
  {
    type: "buttonBlock",
    propSchema: {
      buttonType: {
        values: ["Link", "Phone", "Email"],
        default: "Link",
      },
      url: {
        default: "",
      },
      email: {
        default: "",
      },
      phone: {
        default: "",
      },
      buttonTextColor: {
        default: "",
      },
      buttonBackgroundColor: {
        default: "",
      },
      buttonTextAlignment: {
        values: ["Center", "Default"],
        default: "Default",
      },
      buttonBorderRadius: {
        values: ["Rounded", "Smooth", "Square"],
        default: "",
      },
    },
    content: "inline",
    isSelectable: true,
  },
  {
    render: ({
      contentRef,
      editor,
      block: {
        id,
        props: {
          buttonType,
          url,
          email,
          phone,
          buttonTextColor,
          buttonBackgroundColor,
          buttonTextAlignment,
          buttonBorderRadius,
        },
      },
    }) => {
      const updateBlock = (newProps: Partial<{ buttonType: string; url: string; email: string; phone: string }>) => {
        // biome-ignore lint/suspicious/noExplicitAny:
        editor.updateBlock(id, { props: newProps as any });
      };

      return (
        <ButtonBlock
          blockId={id}
          updateBlock={updateBlock}
          contentRef={contentRef}
          buttonType={buttonType}
          url={url}
          email={email}
          phone={phone}
          buttonBorderRadius={buttonBorderRadius}
          buttonTextAlignment={buttonTextAlignment}
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
        />
      );
    },
    toExternalHTML: ({
      block: {
        props: {
          buttonType,
          email,
          url,
          phone,
          buttonTextColor,
          buttonBackgroundColor,
          buttonTextAlignment,
          buttonBorderRadius,
        },
      },
      contentRef,
    }) => {
      return (
        <InlineButton
          buttonType={buttonType}
          email={email}
          url={url}
          phone={phone}
          contentRef={contentRef}
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
          buttonBorderRadius={buttonBorderRadius}
          buttonTextAlignment={buttonTextAlignment}
        />
      );
    },
  },
);
